import type { Entry } from "@/types";
import { stringifyCsv } from "./csv";

export const TRACKER_CSV_COLUMNS = [
  "kind",
  "name",
  "description",
  "category",
  "subcategory",
  "amount",
  "currency",
  "date",
] as const;

/** YYYY-MM-DD for API date or ISO datetime strings */
function normalizeEntryDate(entry: Entry): string {
  const raw = entry.spentAt;
  if (typeof raw !== "string" || raw.length === 0) return "";
  return raw.includes("T") ? raw.slice(0, 10) : raw;
}

/** Builds CSV for the tracker table (positive amounts; kind = expense | gain). */
export function buildTrackerCsv(entries: Entry[]): string {
  const rows: string[][] = [[...TRACKER_CSV_COLUMNS]];
  for (const e of entries) {
    const amount = Number(e.amount);
    rows.push([
      e.kind ?? "expense",
      e.name ?? "",
      e.description ?? "",
      e.category?.name ?? "",
      e.subcategory?.name ?? "",
      Number.isNaN(amount) ? "" : amount.toFixed(2),
      e.currency ?? "",
      normalizeEntryDate(e),
    ]);
  }
  return stringifyCsv(rows);
}

export function trackerCsvHeadersMatch(headerRow: string[]): boolean {
  if (headerRow.length !== TRACKER_CSV_COLUMNS.length) return false;
  return TRACKER_CSV_COLUMNS.every((h, i) => headerRow[i] === h);
}

export { downloadCsvFile } from "./csv";
